import * as Either from "./either";

export type HttpError = {
  type: "HttpError";
  message: string;
  statusCode: number;
  data?: unknown;
  error?: Error;
};

export type GenericError = {
  type: "Fatal" | "Transient";
  message: string;
  data?: unknown;
  error?: Error;
};

const httpError = (
  message: string,
  statusCode: number,
  error?: Error,
  data?: unknown
): HttpError => ({
  type: "HttpError",
  message,
  statusCode,
  ...(error !== undefined ? { error } : {}),
  ...(data !== undefined ? { data } : {})
});

const fatalError = (message: string, error?: Error): GenericError => ({
  type: "Fatal",
  message,
  ...(error !== undefined ? { error } : {})
});

export const fetchJson = async <T>(
  url: string,
  errorMessage: string,
  init?: RequestInit
): Promise<Either.Either<T, HttpError | GenericError>> => {
  try {
    const response = await fetch(url, init);

    if (!response.ok) {
      return Either.left(httpError(errorMessage, response.status));
    }

    const json: T = await response.json();
    return Either.right(json);
  } catch (error) {
    return Either.left(
      fatalError(errorMessage, error instanceof Error ? error : undefined)
    );
  }
};
